module.exports = {
  get(key, defaultValue) {
    var value = window.localStorage[key]
    return (typeof value != 'undefined' ? value : defaultValue)
  },
  set(key, value) {
    window.localStorage[key] = value
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/storage.js
 **/